import React from 'react';
import { stats } from '../../data/content';
export function StatsBar() {
  return <section aria-label="Datos del método" className="w-full bg-pitch" data-id="element-192" data-mp="1j8ma64pvky1q">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-14 gap-y-8 px-5 py-12" data-id="element-193" data-mp="1j6rm4hjb4ptf">
        {stats.map(stat => <div key={stat.label} className="min-w-[120px] text-center" data-id="element-194" data-mp="1syxdbp1qj37k">
            <p className="font-display text-4xl font-black text-brand-gold md:text-5xl" data-id="element-195" data-mp="1x0ajy1cnjafj">
              {stat.value}
            </p>
            <p className="mt-1 text-sm font-semibold text-body" data-id="element-196" data-mp="21yc5qu1gpnup">{stat.label}</p>
          </div>)}
      </div>
    </section>;
}